import PaymentConfigurationInfo from './PaymentConfigurationInfo';

export default PaymentConfigurationInfo